import { type UseQueryOptions, useQuery } from '@tanstack/react-query';

import { post } from 'src/utils/helpers/http';
import { useBaseAPIParams } from 'src/utils/hooks/useBaseAPIParams';

const GET_GUEST_DETAILS = 'v2/guest/details';

export type MobileCheckoutIdentification = {
  ExpirationDate?: string;
  image_url?: string | null;
  number?: string;
  type: string;
};

export type GuestIdentificationDetails = {
  IsMedical: boolean;
  identifications: MobileCheckoutIdentification[];
};

const guestIdentificationKeys = {
  details: (guestId: number, lspId?: number, locId?: number) =>
    ['guest-identification-details', guestId, lspId, locId] as const,
};

type GuestIdentificationPayload = {
  guestId: number;
  options?: Pick<UseQueryOptions<GuestIdentificationDetails>, 'enabled'>;
};

/**
 * The checked-in guest list intentionally omits identification image bytes.
 * Guest details is the existing typed image source used by Register.
 */
export const useGuestIdentificationsQuery = ({ guestId, options }: GuestIdentificationPayload) => {
  const baseAPIParams = useBaseAPIParams();

  return useQuery({
    queryKey: guestIdentificationKeys.details(guestId, baseAPIParams.LspId, baseAPIParams.LocId),
    queryFn: () =>
      post<GuestIdentificationDetails>(GET_GUEST_DETAILS, {
        ...baseAPIParams,
        Guest_id: guestId,
      }),
    enabled: !!guestId && !!baseAPIParams.LspId && !!baseAPIParams.LocId && (options?.enabled ?? true),
    staleTime: 30_000,
  });
};
